import { createFileRoute, notFound } from "@tanstack/react-router";
import {
  getStrategyPartner,
  getStrategyPartnerMetaDescription,
  getStrategyPartnerMetaTitle,
} from "~/features/strategy-partner";

export const Route = createFileRoute("/_app/sp/$partner")({
  head: ({ params }) => ({
    meta: [
      { title: getStrategyPartnerMetaTitle(params.partner) },
      {
        content: getStrategyPartnerMetaDescription(params.partner),
        name: "description",
      },
    ],
  }),
  loader: ({ params }) => {
    if (!getStrategyPartner(params.partner)) {
      throw notFound();
    }
  },
});
